import { render, staticRenderFns } from "./UserTasks.vue?vue&type=template&id=468db956&scoped=true&"
import script from "./UserTasks.vue?vue&type=script&lang=js&"
export * from "./UserTasks.vue?vue&type=script&lang=js&"
import style0 from "./UserTasks.vue?vue&type=style&index=0&id=468db956&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "468db956",
  null
  
)

export default component.exports